var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIconBlack = function SvgInfoIconBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8712_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C10.1266 24 7.80655 23.2962 5.83316 21.9776C3.85977 20.6591 2.3217 18.7849 1.41345 16.5922C0.505199 14.3995 0.267559 11.9867 0.730582 9.65892C1.1936 7.33115 2.33649 5.19295 4.01472 3.51472C5.69295 1.83649 7.83115 0.693605 10.1589 0.230582C12.4867 -0.232441 14.8995 0.00519943 17.0922 0.913451C19.2849 1.8217 21.1591 3.35977 22.4776 5.33316C23.7962 7.30655 24.5 9.62663 24.5 12C24.4966 15.1815 23.2312 18.2318 20.9815 20.4815C18.7318 22.7312 15.6815 23.9966 12.5 24ZM12.5 2.00001C10.5222 2.00001 8.58879 2.5865 6.9443 3.68531C5.29981 4.78412 4.01809 6.34591 3.26121 8.17317C2.50433 10.0004 2.3063 12.0111 2.69215 13.9509C3.078 15.8907 4.03041 17.6725 5.42894 19.0711C6.82746 20.4696 8.60929 21.422 10.5491 21.8079C12.4889 22.1937 14.4996 21.9957 16.3268 21.2388C18.1541 20.4819 19.7159 19.2002 20.8147 17.5557C21.9135 15.9112 22.5 13.9778 22.5 12C22.4971 9.34873 21.4426 6.80689 19.5679 4.93215C17.6931 3.05742 15.1513 2.00292 12.5 2.00001Z",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19H12.5V12H10.5V10H12.5C13.0304 10 13.5391 10.2107 13.9142 10.5858C14.2893 10.9609 14.5 11.4696 14.5 12V19Z",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8C13.3284 8 14 7.32843 14 6.5C14 5.67157 13.3284 5 12.5 5C11.6716 5 11 5.67157 11 6.5C11 7.32843 11.6716 8 12.5 8Z",
    fill: "#171926"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8712_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
export default SvgInfoIconBlack;